module.exports = __webpack_public_path__ + "static/not-be-forgotten-946b78022a0b9859e18f7c023e5bde73.png";